import { render, staticRenderFns } from "./BatchOperate.vue?vue&type=template&id=cb463b72&scoped=true"
import script from "./BatchOperate.vue?vue&type=script&lang=ts"
export * from "./BatchOperate.vue?vue&type=script&lang=ts"
import style0 from "./BatchOperate.vue?vue&type=style&index=0&id=cb463b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb463b72",
  null
  
)

export default component.exports